/**
 * Node-safe brand metadata.
 *
 * Deliberately free of asset imports / `import.meta` so it can be imported from
 * `vite.config.mts` (Node context) to brand the static `index.html` at build
 * time. The full client-side config lives in `brand.registry.ts`.
 */
import type { BrandKey } from './brand.types'

export interface IBrandMeta {
  /** Browser tab / document title. */
  title: string
  /** Favicon path served from `public/`. */
  favicon: string
}

// `title` is the static browser-tab title in index.html — Peraso keeps its
// existing value verbatim so the Peraso build is unchanged. The longer runtime
// title (set by router/guards.ts) lives on `IBrandConfig.documentTitle`.
export const BRAND_META: Record<BrandKey, IBrandMeta> = {
  peraso: { title: 'Peraso', favicon: '/favicon.ico' },
  // DUNE reuses Peraso's favicon for the initial release.
  dune: { title: 'DUNE Wireless', favicon: '/favicon.ico' },
}
